import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Box, Typography, Tab, Tabs, Button } from '@mui/material';
import ContestDetailsView from '../components/ContestDetailsView';
import RankingView from '../components/RankingView';
import RulesView from '../components/RulesView';
import useContestName from '../utils/useContestName';

const ContestPage: React.FC = () => {
  const { contestId } = useParams<{ contestId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<number>(0);
  const { contestName, loading, error } = useContestName(contestId);

  useEffect(() => {
    // Check for `tab` and `group` parameters in the URL
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');

    // Update tab based on the `tab` parameter
    if (tabParam) {
      const tabIndex = parseInt(tabParam, 10);
      if (!isNaN(tabIndex) && tabIndex !== activeTab) {
        setActiveTab(tabIndex);
      }
    }
  }, [location.search, activeTab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    navigate(`?tab=${newValue}`);
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(-1)}
          style={{ marginRight: '10px', marginBottom: 10 }}
        >
          &lt;&lt;
        </Button>
        <Typography variant="h5" gutterBottom style={{ flexGrow: 1 }} color="primary">
          {loading ? 'Loading contest...' : contestName || error}
        </Typography>
      </Box>

      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tab label="Лента" />
        <Tab label="Рейтинг" />
        <Tab label="Правила" />
      </Tabs>

      <Box mt={3} sx={{ maxWidth: { xs: '100%', lg: '1200px' }, margin: '0 auto', overflowX: 'auto' }}>
        {activeTab === 0 && <ContestDetailsView />}
        {activeTab === 1 && <RankingView />}
        {activeTab === 2 && <RulesView />}
      </Box>
    </Box>
  );
};

export default ContestPage;
